import React, { createContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { apiClient } from "../api/apiServices";
import { toast } from "react-toastify";

export const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() =>
    localStorage.getItem("access_token")
  );
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLogin = (token, userData = null) => {
  setToken(token);
  localStorage.setItem("access_token", token);
  apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;

  try {
    const decoded = jwtDecode(token);
    const mergedUser = {
      ...decoded,
      ...userData,
      userId: userData?.userId || decoded?.userId,
      email: userData?.email || decoded?.email,
    };

    setUser(mergedUser);
    return mergedUser;
  } catch (err) {
    console.error("Failed to decode token:", err);
    return null;
  }
};


  // console.log("Me", user);
  const handleLogout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("access_token");
    localStorage.clear();
    delete apiClient.defaults.headers.common["Authorization"];
  };

  useEffect(() => {
    const existingToken = localStorage.getItem("access_token");
    if (existingToken) {
      apiClient.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${existingToken}`;
      setToken(existingToken);
    }
  }, []);

  useEffect(() => {
    const existingToken = localStorage.getItem("access_token");

    if (existingToken) {
      try {
        const decoded = jwtDecode(existingToken);

        if (decoded.exp * 1000 < Date.now()) {
          // Token expired
          handleLogout();
          toast.info("Session expired. Please login again.");
        } else {
          setToken(existingToken);
          setUser(decoded);
          apiClient.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${existingToken}`;
        }
      } catch (err) {
        console.error("Invalid token:", err);
        handleLogout();
        toast.info("Session expired. Please login again.");
      }
    }
    setLoading(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        token,
        user,
        loading,
        setUser,
        login: handleLogin,
        logout: handleLogout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
